import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts, glyphs } from "../../../Styles";
import { NewModal, ToggleBox, NewButton } from "../.."
import { ToggleStyles } from "../../../Definitions";
import { Graph_QL, useSystem, useUser } from "../../../Services"
import { UsersWithGroups } from "../../../Services/Agrisys_GqlDataCaller/UserCalls/GQLCalls/workerListCalls";
import { useAppSelector } from "../../../Store";

export interface WorkerListModalProps {
  worker: UsersWithGroups
  closeModal: () => void
}

export default function WorkerListModal({ worker, closeModal }: WorkerListModalProps) {
  const { t } = useTranslation();
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({ domain: farm })), [farm]);
  const connection = useMemo(() => (Graph_QL.create({ domain: farm })), [farm]);

  const { setUserAttentionEmailSystems, getWorkerList } = useUser()
  const { data: systemsState } = useSystem(connection);

  const systems = useMemo(() => {
    return systemsState?.[domain]?.data || [];
  }, [domain, systemsState]);

  const [userSystems, setUserSystems] = useState(systems.map(e => ({ ...e, isChecked: worker.attention_email_systems?.includes(e.system_id) ?? false })));

  function handleSave() {
    const systemsToAdd: number[] = userSystems.filter(e => e.isChecked).map(e => e.system_id);
    setUserAttentionEmailSystems(farm, worker.username, systemsToAdd)
      .then(() => {
        getWorkerList(farm, true).then(e=>{if(!e) getWorkerList(farm)});
        closeModal();
      })
    .catch(() => { });
  }

  return (
    <NewModal
      header={t("globalSettingsPages.globalSettings.workerManagement", {defaultValue: "worker management"})}
      subHeader={`${t("globalSettingsPages.globalSettings.settingsFor", {defaultValue: "settings for"})} ${worker.username}`}
      overrides={{
        mainContentPadding: "0px 20px 20px 20px",
        // headerHeight: "60px"
      }}
      predefinedButtons={{ onClose: closeModal }}
      mainContent={
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", border: "2px solid "+colors.blueDarkSecondary, borderLeft: "none", borderRight: "none", padding: "20px 0px" }}>     
          <p style={{ ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary, textAlign: "center" }}>
            {t("globalSettingsPages.globalSettings.emailAttentionDisclaimerWorker", { defaultValue: "Choose which systems your worker should receive attentions from" })}:
          </p>
             
          <div style={{display: "grid", gridTemplateColumns: "auto 1fr", gap: "10px 50px", width: "fit-content", margin: "0 auto"}}>
            {userSystems.map(system =>
              <ToggleBox
                text={system.name}
                isChecked={system.isChecked}
                onChange={() => { setUserSystems(prev => prev.map(s => s.system_id === system.system_id ? { ...s, isChecked: !s.isChecked } : s)); } }
                key={system.system_id}
                icon={glyphs.Mail({ size: "16px" })}
                toggleStyles={ToggleStyles.blueDarkSecondary}
              />
            )}  
          </div>
        </div>
      }
      footerContent={
        <NewButton
          content={t("buttons.save", { defaultValue: "save" })}
          onClick={handleSave}
        />
      }
    />
  );
}